module.exports = __webpack_public_path__ + "img/pngegg.14f5291c.png";